/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-bookmark': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15 2.5v14.219l-4.438-2.244-.562-.281-.563.281L5 16.719V2.5h10zm0-1.25H5c-.69 0-1.25.56-1.25 1.25v16.25L10 15.625l6.25 3.125V2.5c0-.69-.56-1.25-1.25-1.25z"/>'
  }
})
